import { Advnture } from './definitions/Advnture';
import { AndroidCentral } from './definitions/AndroidCentral';
import { AVNetwork } from './definitions/AVNetwork';
import { BikePerfect } from './definitions/BikePerfect';
import { Cinemablend } from './definitions/Cinemablend';
import { CoachMag } from './definitions/CoachMag';
import { ComputerActive } from './definitions/ComputerActive';
import { CountryHomesandInteriors } from './definitions/CountryHomesandInteriors';
import { CountryLife } from './definitions/CountryLife';
import { CreativeBloq } from './definitions/CreativeBloq';
import { Cucina } from './definitions/Cucina';
import { Cyclingnews } from './definitions/Cyclingnews';
import { CyclingWeekly } from './definitions/CyclingWeekly';
import { Decanter } from './definitions/Decanter';
import { DigitalCameraWorld } from './definitions/DigitalCameraWorld';
import { Discover } from './definitions/Discover';
import { FitAndWell } from './definitions/FitAndWell';
import { FiveGRadar } from './definitions/FiveGRadar';
import { FourFourTwo } from './definitions/FourFourTwo';
import { GamesRadar } from './definitions/GamesRadar';
import { Gardeningetc } from './definitions/Gardeningetc';
import { GardeningKnowHow } from './definitions/GardeningKnowHow';
import { GetPriceAU } from './definitions/GetPriceAU';
import { GetPriceNZ } from './definitions/GetPriceNZ';
import { GnomesInGardens } from './definitions/GnomesInGardens';
import { GoCompare } from './definitions/GoCompare';
import { GolfMonthly } from './definitions/GolfMonthly';
import { GoodToKnow } from './definitions/GoodToKnow';
import { GuitarPlayer } from './definitions/GuitarPlayer';
import { GuitarWorld } from './definitions/GuitarWorld';
import { HomeBuilding } from './definitions/HomeBuilding';
import { HomesAndGardens } from './definitions/HomesAndGardens';
import { HorseAndHound } from './definitions/HorseAndHound';
import { IdealHome } from './definitions/IdealHome';
import { IMore } from './definitions/IMore';
import { ITPro } from './definitions/ITPro';
import { ITProPortal } from './definitions/ITProPortal';
import { Kiplinger } from './definitions/Kiplinger';
import { LaptopMag } from './definitions/LaptopMag';
import { LiveScience } from './definitions/LiveScience';
import { Livingetc } from './definitions/Livingetc';
import { LookAfterMyBills } from './definitions/LookAfterMyBills';
import { LouderSound } from './definitions/LouderSound';
import { MarieClaireUK } from './definitions/MarieClaireUK';
import { MarieClaireUS } from './definitions/MarieClaireUS';
import { MoneyWeek } from './definitions/MoneyWeek';
import { MotorBoatAndYachting } from './definitions/MotorBoatAndYachting';
import { MountainBikeRider } from './definitions/MountainBikeRider';
import { MusicRadar } from './definitions/MusicRadar';
import { MusicWeek } from './definitions/MusicWeek';
import { MyImperfectLife } from './definitions/MyImperfectLife';
import { MyVoucherCodes } from './definitions/MyVoucherCodes';
import { NextTV } from './definitions/NextTV';
import { PCGamer } from './definitions/PCGamer';
import { PCPro } from './definitions/PCPro';
import { PetsRadar } from './definitions/PetsRadar';
import { PracticalBoatOwner } from './definitions/PracticalBoatOwner';
import { PracticalCaravan } from './definitions/PracticalCaravan';
import { PracticalMotorhome } from './definitions/PracticalMotorhome';
import { PricePandaID } from './definitions/PricePandaID';
import { PricePandaMY } from './definitions/PricePandaMY';
import { PricePandaPH } from './definitions/PricePandaPH';
import { PricePandaSG } from './definitions/PricePandaSG';
import { PricePandaTH } from './definitions/PricePandaTH';
import { RealHomes } from './definitions/RealHomes';
import { Rooms } from './definitions/Rooms';
import { RugbyWorld } from './definitions/RugbyWorld';
import { SheerLuxe } from './definitions/SheerLuxe';
import { ShootingUK } from './definitions/ShootingUK';
import { Shortlist } from './definitions/Shortlist';
import { Space } from './definitions/Space';
import { T3 } from './definitions/T3';
import { TechLearning } from './definitions/TechLearning';
import { TechRadar } from './definitions/TechRadar';
import { TechRadarPro } from './definitions/TechRadarPro';
import { TheBlend } from './definitions/TheBlend';
import { TheField } from './definitions/TheField';
import { TheMoneyEdit } from './definitions/TheMoneyEdit';
import { ThePrivacyLab } from './definitions/ThePrivacyLab';
import { TheRadar } from './definitions/TheRadar';
import { TheReset } from './definitions/TheReset';
import { TheWeek } from './definitions/TheWeek';
import { Thrifter } from './definitions/Thrifter';
import { TomsGuide } from './definitions/TomsGuide';
import { TomsHardware } from './definitions/TomsHardware';
import { TopTenReviews } from './definitions/TopTenReviews';
import { Truly } from './definitions/Truly';
import { TVTechnology } from './definitions/TVTechnology';
import { Wallpaper } from './definitions/Wallpaper';
import { WhatCulture } from './definitions/WhatCulture';
import { WhatHiFi } from './definitions/WhatHiFi';
import { WhatToWatch } from './definitions/WhatToWatch';
import { WhoWhatWear } from './definitions/WhoWhatWear';
import { WindowsCentral } from './definitions/WindowsCentral';
import { Woman } from './definitions/Woman';
import { WomanAndHome } from './definitions/WomanAndHome';
import { WomansOwn } from './definitions/WomansOwn';
import { YachtingAndBoatingWorld } from './definitions/YachtingAndBoatingWorld';
import { YachtingMonthly } from './definitions/YachtingMonthly';
import { YachtingWorld } from './definitions/YachtingWorld';
import type { Site } from './Site';

export const practicalSites: Site[] = [PracticalCaravan, PracticalMotorhome];

export const progressiveSites: Site[] = [
  TheBlend,
  CyclingWeekly,
  FitAndWell,
  Gardeningetc,
  GardeningKnowHow,
  GnomesInGardens,
  GolfMonthly,
  GoodToKnow,
  HomesAndGardens,
  IdealHome,
  ITPro,
  Kiplinger,
  Livingetc,
  MarieClaireUK,
  MarieClaireUS,
  MyImperfectLife,
  MyVoucherCodes,
  MoneyWeek,
  RealHomes,
  SheerLuxe,
  Shortlist,
  TheWeek,
  T3,
  WomanAndHome,
  Wallpaper,
  WhoWhatWear,
  CountryLife,
  Decanter,
  HorseAndHound,
  MusicWeek,
];

export const responsiveSites: Site[] = [
  FiveGRadar,
  Advnture,
  AndroidCentral,
  AVNetwork,
  BikePerfect,
  Cinemablend,
  CreativeBloq,
  Cyclingnews,
  CoachMag,
  DigitalCameraWorld,
  FourFourTwo,
  GetPriceAU,
  GetPriceNZ,
  PricePandaID,
  PricePandaMY,
  PricePandaPH,
  PricePandaSG,
  PricePandaTH,
  GamesRadar,
  GuitarPlayer,
  GuitarWorld,
  HomeBuilding,
  IMore,
  LaptopMag,
  LiveScience,
  LouderSound,
  MusicRadar,
  NextTV,
  PCGamer,
  PetsRadar,
  Space,
  TechLearning,
  TheRadar,
  TomsGuide,
  TomsHardware,
  TopTenReviews,
  TechRadar,
  TechRadarPro,
  TVTechnology,
  WhatHiFi,
  WhatToWatch,
  WindowsCentral,
];

export const tiSites: Site[] = [
  MountainBikeRider,
  MotorBoatAndYachting,
  PracticalBoatOwner,
  RugbyWorld,
  YachtingMonthly,
  YachtingWorld,
  YachtingAndBoatingWorld,
];

export const hawklinksOnlySites: Site[] = [
  TheField,
  Discover,
  Woman,
  WomansOwn,
  WhatCulture,
  LookAfterMyBills,
  TheReset,
  Rooms,
  CountryHomesandInteriors,
  ComputerActive,
  GoCompare,
  ITProPortal,
  PCPro,
  ShootingUK,
  Cucina,
  TheMoneyEdit,
  ThePrivacyLab,
  Thrifter,
  Truly,
];

export default [
  ...responsiveSites,
  ...progressiveSites,
  ...tiSites,
  ...practicalSites,
  ...hawklinksOnlySites,
].sort((a: Site, b: Site) => {
  if (a.label < b.label) {
    return -1;
  }
  return 1;
});
